import { AxiosInstance } from '../../utilities/requestClient';
import { GetPositionDatesParams, PositionDatesMap } from './types';

/**
 * Constructs the URL for fetching position dates.
 */
export const getPositionDatesURL = ({
  fundTypes,
  rsResources,
  raptorPlatformId,
}: GetPositionDatesParams) => {
  const params: string[] = [];

  if (fundTypes?.length) params.push(`schemas=${fundTypes}`);
  if (rsResources?.length) params.push(`rs_resources=${rsResources}`);
  if (raptorPlatformId?.length)
    params.push(`raptor_platform_id=${raptorPlatformId}`);

  const queryString = params.length ? `?${params.join('&')}` : '';
  return `get_position_dates${queryString}`;
};

/**
 * Fetch available position dates for a section (overview + per-fund map).
 */
export const getPositionDates = async (
  params: GetPositionDatesParams,
): Promise<PositionDatesMap> => {
  const route = getPositionDatesURL(params);
  return (await AxiosInstance.get<PositionDatesMap>(`/${route}`)).data;
};
